export const constants = {
	SET_PAGES: 'SET_PAGES',
	SET_ACTIVE_PAGE: 'SET_ACTIVE_PAGE',
	SET_ACTIVE_PAGE_ID: 'SET_ACTIVE_PAGE_ID',
	IS_FETCHING: 'IS_FETCHING'
}
